import { useId, useState } from 'react';
import { glossaryMatchPatterns, getGlossaryById } from '../data/alineaGlossary.js';
import './GlossaryTerm.css';

const PATTERNS = glossaryMatchPatterns();

function escapeRegex(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function splitTextWithGlossary(text) {
    if (!text || typeof text !== 'string') return [{ type: 'text', value: String(text ?? '') }];
    const regex = new RegExp(
        `(${PATTERNS.map((p) => escapeRegex(p.phrase)).join('|')})`,
        'gi'
    );
    const parts = text.split(regex).filter((p) => p !== '');
    return parts.map((part) => {
        const hit = PATTERNS.find((p) => p.phrase.toLowerCase() === part.toLowerCase());
        if (hit) return { type: 'term', value: part, entry: hit.entry };
        return { type: 'text', value: part };
    });
}

/** Palabra o frase con botón ℹ y explicación al tocar/clic. */
export function GlossaryTerm({ termId, label, className = '' }) {
    const entry = getGlossaryById(termId);
    const [open, setOpen] = useState(false);
    const popId = useId();
    if (!entry) return <span className={className}>{label || termId}</span>;

    const text = label || entry.title;

    return (
        <span className={`glossary-term ${className}`.trim()}>
            <button
                type="button"
                className="glossary-term-trigger"
                aria-expanded={open}
                aria-describedby={open ? popId : undefined}
                onClick={() => setOpen((v) => !v)}
            >
                {text}
                <span className="glossary-term-icon" aria-hidden>
                    ℹ
                </span>
            </button>
            {open ? (
                <span id={popId} role="tooltip" className="glossary-term-popover">
                    <strong>{entry.title}</strong>
                    <span>{entry.definition}</span>
                    <button type="button" className="glossary-term-close" onClick={() => setOpen(false)}>
                        Cerrar
                    </button>
                </span>
            ) : null}
        </span>
    );
}

/** Párrafo con términos del glosario detectados automáticamente. */
export function GlossaryText({ children, className = '' }) {
    const parts = splitTextWithGlossary(children);
    return (
        <span className={className}>
            {parts.map((part, i) =>
                part.type === 'term' ? (
                    <GlossaryTerm key={`${part.entry.id}-${i}`} termId={part.entry.id} label={part.value} />
                ) : (
                    <span key={`t-${i}`}>{part.value}</span>
                )
            )}
        </span>
    );
}
